/* eslint-disable global-require */
/* eslint-disable no-eval */
/* eslint-disable eqeqeq */
import { getFlagsContext } from './utils/rollout';

const canUseDOM = (typeof window != 'undefined' && window.document);
let roxBrowser = null;
if (canUseDOM) {
    roxBrowser = require('rox-browser');
}
const Rox = canUseDOM ? roxBrowser : eval('require(\'rox-node\')');

class UtrRoxFlag extends Rox.Flag {
    isEnabled = (user) => {
        return super.isEnabled(getFlagsContext(user));
    }
}

export default {
    testFlag: new UtrRoxFlag(),
    showHeader: new UtrRoxFlag(),
    clubMemberManagementFlag: new UtrRoxFlag(),
    playerProfileBetaFlag: new UtrRoxFlag(),
    profileEditBetaFlag: new UtrRoxFlag(),
    dashBoardBetaFlag: new UtrRoxFlag(),
    verifiedClubFlag: new UtrRoxFlag(),
    freshchat: new UtrRoxFlag(),
    photoGalleryFlag: new UtrRoxFlag(),
    showAllMatches: new UtrRoxFlag(),
    photoFlag: new UtrRoxFlag(),
    betaFeatureFlag: new UtrRoxFlag(),
    // locationSearch: new UtrRoxFlag(),
    bookmarks: new UtrRoxFlag(),
    power6Search: new UtrRoxFlag(),
    proPoweredTopLevelFlag: new UtrRoxFlag(),
    newHeader: new UtrRoxFlag(),
    messaging: new UtrRoxFlag(),
    messagePolling: new UtrRoxFlag(),
    personalClub: new UtrRoxFlag(),
    postScoreFlag: new UtrRoxFlag(),
    resetEventDrawsFlag: new UtrRoxFlag(),
    clubCreateFlag: new UtrRoxFlag(),
    referralSystem: new UtrRoxFlag(),
    couponSystem: new UtrRoxFlag(),
    recruiting3_0: new UtrRoxFlag(),
    upgradeCollegeFlag: new UtrRoxFlag(),
    enterpriseClubFlag: new UtrRoxFlag(),
    clubPostScoreFlag: new UtrRoxFlag(),
    dualMatchProfileFlag: new UtrRoxFlag(),
    enterScoresOldSiteFlag: new UtrRoxFlag(),
    toursSearchFilterFlag: new UtrRoxFlag(),
    pendingMemberRestrictions: new UtrRoxFlag(),
    moneyTournaments: new UtrRoxFlag(),
    playerTagsSearchFlag: new UtrRoxFlag(),
    playerAgeTagsSearchFlag: new UtrRoxFlag(),
    summerSeriesFlag: new UtrRoxFlag(),
    memberFileFlag: new UtrRoxFlag(),
    demoEventFlag: new UtrRoxFlag(),
    createPlayerGroupMainMenu: new UtrRoxFlag(),
    createPlayerGroupPlusButton: new UtrRoxFlag(),
    eventFilters: new UtrRoxFlag(),
    playerMetricsFlag: new UtrRoxFlag(),
    doublesPlayerMetricsFlag: new UtrRoxFlag(),
    highSchoolDualMatch: new UtrRoxFlag(),
    additionalHSRankLists: new UtrRoxFlag(),
    addMembersToolFlag: new UtrRoxFlag(),
    refer25FreePowerPromo: new UtrRoxFlag(),
    nonTennisEventFlag: new UtrRoxFlag(),
    playerProfileRanking: new UtrRoxFlag(),
    playerCompareFlag: new UtrRoxFlag(),
    ratingsListFlag: new UtrRoxFlag(),
    highSchoolEventTypes: new UtrRoxFlag(),
    carouselType: new Rox.Variant('video', ['video', 'image']),
    redirectPtsToHome: new UtrRoxFlag(),
    ptsShowMockEvents: new UtrRoxFlag(),
    themeV2: {
        isEnabled: () => {
            return true;
        },
    },
    adultTeamClubsSearch: new UtrRoxFlag(),
    createPlayFlag: new UtrRoxFlag(),
    marketingIOSAppFlag: new UtrRoxFlag(),
    juniorTeamTennisFlag: new UtrRoxFlag(),
    adultTeamTennisFlag: new UtrRoxFlag(),
    teamTennisFlag: new UtrRoxFlag(),
};
